module.exports = __webpack_public_path__ + "img/25-armenian.686d344d.svg";